var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import { Col, Row } from "react-bootstrap";
import "@frameworks/salesjourney/stylesheets/components/Login/Login.scss";
import ImagePage from "./LoginPages/ImagePage";
import LoginMain from "./LoginPages/LoginMain";
import ForgotPassword from "./LoginPages/ForgotPassword";
import ResetPassword from "./LoginPages/ResetPassword";
import UnblockAccount from "./LoginPages/UnblockAccount";
import nameLogo from "@frameworks/shared-library/assets/images/generic/nuvama_name_logo.png";
import { ECurrentLoginComponent } from "@domains/salesFeatures/Login/entities/iLogin";
import { useSelector } from "react-redux";
import ForgotLoginID from "./LoginPages/ForgotLoginID";
import ForgotLoginIdSuccess from "./LoginPages/ForgotLoginIdSuccess";
import { LogoLoader } from "@frameworks/shared-library/components/Loader";
import { getQueryParameterName } from "@frameworks/salesjourney/utils/genericMethods";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
export var ERole;
(function (ERole) {
    ERole["RM"] = "RM";
    ERole["Partner"] = "Partner";
})(ERole || (ERole = {}));
var Login = function () {
    var ssoCode = getQueryParameterName("code");
    var _a = __read(React.useState(ERole.RM), 2), activeLoginTab = _a[0], setActiveLoginTab = _a[1];
    var _b = __read(React.useState(""), 2), partnerCode = _b[0], setPartnerCode = _b[1];
    var _c = __read(useState(), 2), userDataForUnblock = _c[0], setUserDataForUnblock = _c[1];
    var _d = __read(useState(false), 2), loader = _d[0], setLoader = _d[1];
    var currentLoginComponent = useSelector(function (state) { return state.Login.LoginComponentReducer.reducersData; });
    React.useEffect(function () {
        if (currentLoginComponent.extraConfig &&
            currentLoginComponent.extraConfig.currentActiveTab) {
            setActiveLoginTab(currentLoginComponent.extraConfig.currentActiveTab);
        }
    }, [currentLoginComponent]);
    var GenerateLoginComponent = function () {
        var _a, _b, _c, _d, _e;
        switch (currentLoginComponent.currentComponent) {
            case ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS:
                return (React.createElement(GenericTabs, { externalClassName: "common-tab-color login-tabs", defaultActiveKey: activeLoginTab, key: activeLoginTab, callBackFunction: function (activeKey) {
                        setActiveLoginTab(activeKey);
                    }, tabsArray: [
                        {
                            title: ERole.RM,
                            eventKey: ERole.RM,
                            tabContent: (React.createElement("div", { className: "login-content" },
                                React.createElement(LoginMain, { loginFor: activeLoginTab, userId: partnerCode, setUserId: setPartnerCode, userDataForUnblock: userDataForUnblock, setUserDataForUnblock: setUserDataForUnblock, setLoader: setLoader, ssoCode: ssoCode }))),
                        },
                        {
                            title: ERole.Partner,
                            eventKey: ERole.Partner,
                            tabContent: (React.createElement("div", { className: "login-content" },
                                ((_a = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _a === void 0 ? void 0 : _a.tabMessage) && (React.createElement("div", { className: "d-flex align-items-center justify-content-center gap-2 tab-header ".concat((_b = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _b === void 0 ? void 0 : _b.tabMessageClass) },
                                    ((_c = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _c === void 0 ? void 0 : _c.messageIcon) &&
                                        ((_d = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _d === void 0 ? void 0 : _d.messageIcon),
                                    React.createElement("span", null, (_e = currentLoginComponent === null || currentLoginComponent === void 0 ? void 0 : currentLoginComponent.extraConfig) === null || _e === void 0 ? void 0 : _e.tabMessage))),
                                React.createElement(LoginMain, { loginFor: activeLoginTab, userId: partnerCode, setUserId: setPartnerCode, userDataForUnblock: userDataForUnblock, setUserDataForUnblock: setUserDataForUnblock, setLoader: setLoader }))),
                        },
                    ] }));
            case ECurrentLoginComponent.FORGOT_PASSWORD:
                return (React.createElement(ForgotPassword, { partnerCode: partnerCode, setPartnerCode: setPartnerCode }));
            case ECurrentLoginComponent.FORGOT_LOGIN_ID:
                return React.createElement(ForgotLoginID, { showBackToLogin: true });
            case ECurrentLoginComponent.RESET_PASSWORD:
                return (React.createElement(ResetPassword, { partnerCode: partnerCode, setPartnerCode: setPartnerCode, isChangePassword: false }));
            case ECurrentLoginComponent.UNBLOCK_ACCOUNT:
                return (React.createElement(UnblockAccount, { loginFor: activeLoginTab, userData: userDataForUnblock, userId: partnerCode }));
            case ECurrentLoginComponent.FORGOT_LOGIN_ID_SUCCESS:
                return React.createElement(ForgotLoginIdSuccess, null);
        }
    };
    React.useEffect(function () {
        if (currentLoginComponent.extraConfig &&
            currentLoginComponent.extraConfig.currentActiveTab) {
            setActiveLoginTab(currentLoginComponent.extraConfig.currentActiveTab);
        }
    }, [currentLoginComponent]);
    React.useEffect(function () {
        if (window.top !== window.self) {
            window.top.location = window.self.location;
        }
        profileDI.profile.clearLoginDetails();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "w-100 d-flex justify-content-center position-fixed" },
            React.createElement(Col, { md: 7, lg: 7, xl: 7, className: "image-section" },
                React.createElement(ImagePage, null)),
            React.createElement(Col, { md: 5, lg: 5, xl: 5, className: "d-flex justify-content-start login flex-column" },
                loader && React.createElement(LogoLoader, null),
                React.createElement("div", { className: "d-flex justify-content-center align-items-center w-100  ".concat(activeLoginTab === ERole.RM ? "mb-4" : "header-logo") },
                    React.createElement("img", { src: nameLogo, alt: "nuvama", width: 150 })),
                React.createElement(React.Fragment, null, GenerateLoginComponent())))));
};
export default Login;
